import { FC } from "react";

import merge from "lodash/merge";
import getContentTypeForExtension from "utils/getContentTypeForExtension";

import CsvFilePreview from "./CsvFilePreview";
import FilePreviewUnavailableView from "./FilePreviewUnavailableView";
import { FileControlWrapper } from "./FilesCache";

export interface FilePreviewViewProps {
  file: FileControlWrapper["file"];
  onClickDownload: () => void;
  objectProps?: JSX.IntrinsicElements["object"];
  inline?: boolean;
  csvMaxRows?: number;
}

const supportedPreviewableExtensions = new Set([
  // documnents
  "PDF",
  // images
  "PNG",
  "JPG",
  "JPEG",
  "GIF",
  // other
  "CSV",
]);

const extensionSpecificObjectPropsMap: Record<string, JSX.IntrinsicElements["object"]> = {
  PDF: {
    width: "100%",
    height: "100%",
  },
};

const FilePreviewView: FC<FilePreviewViewProps> = (props) => {
  if (!props.file.url_preview || !props.file.extension || !supportedPreviewableExtensions.has(props.file.extension)) {
    console.log("Unsupported extension or missing preview URL:", props.file.extension, props.file.url_preview);
    return (
      <FilePreviewUnavailableView
        reason={"extensionUnsupported"}
        file={props.file}
        inline={props.inline}
        onClickDownload={props.onClickDownload}
      />
    );
  }

  const objectProps = merge({}, props.objectProps, extensionSpecificObjectPropsMap[props.file.extension]);

  if (props.file.extension === "CSV") {
    return (
      <CsvFilePreview
        csvUrl={props.file.url_preview}
        className={objectProps.className}
        maxRows={props.csvMaxRows ?? 25}
      />
    );
  }

  return (
    <object
      key={props.file.id}
      data={props.file.url_preview}
      type={getContentTypeForExtension(props.file.extension) || undefined}
      {...objectProps}
    >
      <FilePreviewUnavailableView
        reason={"browserUnsupported"}
        file={props.file}
        inline={props.inline}
        onClickDownload={props.onClickDownload}
      />
    </object>
  );
};

export default FilePreviewView;
